import { render, staticRenderFns } from "./IconCompetency.vue?vue&type=template&id=179f4d10"
import script from "./IconCompetency.vue?vue&type=script&lang=js"
export * from "./IconCompetency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports